<template>
  <div>
    <div class="email-form">
      <form id="email-form" @submit="sendEmail">
        <input type="email" class="user-email" id="useremail"
               name="useremail" placeholder="Twój e-mail" />
        <button type="submit" class="send">Wyślij wyniki</button>
      </form>
      <div class="message-error d-none">Pole e-mail nie może być puste!</div>
      <div class="message-success d-none">Wiadomość wysłano poprawnie.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendEmail',
  props: ['targetTemplate'],
  methods: {
    sendEmail(event) {
      event.preventDefault();
      const useremail = document.querySelector('#useremail').value;

      if (!useremail) {
        const warning = document.querySelector('.message-error');
        warning.classList.remove('d-none');
        return;
      }
      this.$http
        .get(`${window.Quiz.mailerUrl}?template=${this.targetTemplate}&mailto=${useremail}`)
        .then((response) => {
          // console.log(response);
          // console.log('mail sent');
          const msgSuccess = document.querySelector('.message-success');
          msgSuccess.classList.remove('d-none');
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
  .email-form {
  }
  .user-email {
    border: none;
    background: #eee;
    padding: 5px 15px;
    width: 300px;
    max-width: 100%;
  }
  .message-success {
    color: forestgreen;
  }
  .message-error {
    color: crimson;
  }
</style>
